// extracted by mini-css-extract-plugin
module.exports = {"feedback__button":"o2-sc-feedback_feedback__button__8JJY6","feedback":"o2-sc-feedback_feedback__80bk9","feedback__buttons":"o2-sc-feedback_feedback__buttons__Zspre"};